export default __webpack_public_path__ + "static/media/guide0305_m.2fa09e7d.jpg";